export type InstallerReleaseNote = {
    version: string;
    releasedOn: string;
    highlights: string[];
};

// Keep newest first so UI can quickly show the latest changes.
export const INSTALLER_RELEASE_NOTES: InstallerReleaseNote[] = [
    {
        version: '3.6.3',
        releasedOn: '2026-06-03',
        highlights: [
            'Installer: add a Start Menu shortcut for Organ Configurator under Content.',
            'Organ Configurator: start in fullscreen from the installer shortcut.',
        ],
    },
    {
        version: '3.6.1',
        releasedOn: '2026-05-28',
        highlights: [
            'Organ Configurator: add KeyChange option (CX12 only) and related installer flow updates.',
            'Installer: robust version bump path handling and improved build script reliability.',
        ],
    },
    {
        version: '3.5.9',
        releasedOn: '2026-05-28',
        highlights: [
            'Installer: improved SSH permission repair flow (fix-ssh).',
            'Startup Launcher: keepLoopMIDI handling improvements.',
            'Content Agent: reliability updates for update/install execution.',
        ],
    },
    {
        version: '3.5.8',
        releasedOn: '2026-05-27',
        highlights: [
            'Installer: updated scheduled task principal behavior for user logon flow.',
        ],
    },
];
